module.exports = __webpack_public_path__ + "@/assets/img/049-boy-22.7edd582d.svg";